// extracted by mini-css-extract-plugin
module.exports = {"dialogActions":"dialogActions_dialogActions__2nnB1"};